<template>
    <div class="language-page">

        <page-title title="main.lang-switcher" />

        <!-- GENERAL APP LANGUAGE SECTION -->
        <div class="section-title">{{ $t('main.appLanguage') || 'Langue de l\'application' }}</div>
        <div class="language-options">
            <label class="language-option" :class="{ active: currentLang === 'fr' }">
                <input 
                    type="radio" 
                    name="language" 
                    value="fr" 
                    :checked="currentLang === 'fr'"
                    @change="switchLang('fr')"
                />
                <span class="radio-custom"></span>
                <span class="language-name">Français</span>
            </label>
            
            <label class="language-option" :class="{ active: currentLang === 'en' }">
                <input 
                    type="radio" 
                    name="language" 
                    value="en" 
                    :checked="currentLang === 'en'"
                    @change="switchLang('en')"
                />
                <span class="radio-custom"></span>
                <span class="language-name">Anglais</span>
            </label>
            
            <label class="language-option" :class="{ active: currentLang === 'ar' }">
                <input 
                    type="radio" 
                    name="language" 
                    value="ar" 
                    :checked="currentLang === 'ar'"
                    @change="switchLang('ar')"
                />
                <span class="radio-custom"></span>
                <span class="language-name">العربية</span>
            </label>
        </div>

        <!-- PRICE READING LANGUAGE SECTION -->
        <div class="section-title">{{ $t('main.priceReadingLanguage') || 'Langue de lecture des prix' }}</div>
        <div class="language-options">

            <label class="language-option" :class="{ active: currentPriceLang === 'fr' }">
                <input
                    type="radio"
                    name="priceLanguage"
                    value="fr"
                    :checked="currentPriceLang === 'fr'"
                    @change="switchPriceLang('fr')"
                />
                <span class="radio-custom"></span>
                <span class="language-name">Français</span>
            </label>

              <label class="language-option" :class="{ active: currentPriceLang === 'ar' }">
                <input
                    type="radio"
                    name="priceLanguage"
                    value="ar"
                    :checked="currentPriceLang === 'ar'"
                    @change="switchPriceLang('ar')"
                />
                <span class="radio-custom"></span>
                <span class="language-name">العربية</span>
            </label>
        </div>

    </div>
</template>

<script>
import Cookies from 'js-cookie';
import PageTitle from '@/components/templates/PageTitle.vue';

export default {
    components: { PageTitle },
    name: 'LanguagePage',
    data() {
        return {
            currentLang: 'fr',
            currentPriceLang: 'fr', // NEW
        };
    },
    created() {
        // APP LANGUAGE
        const saved = Cookies.get('lang');
        if (saved) {
            this.currentLang = saved;
            this.$i18n.locale = saved;
        } else {
            this.currentLang = this.$i18n.locale;
        }

        // PRICE READING LANGUAGE
        const savedPrice = Cookies.get('price_lang');
        if (savedPrice) {
            this.currentPriceLang = savedPrice;
        }

        // Set initial RTL/LTR direction
        document.documentElement.setAttribute('dir', this.currentLang === 'ar' ? 'rtl' : 'ltr');
        document.documentElement.setAttribute('lang', this.currentLang);
    },
    methods: {
        switchLang(lang) {
            this.currentLang = lang;
            this.$i18n.locale = lang;
            Cookies.set('lang', lang, { expires: 365 });

            document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
            document.documentElement.setAttribute('lang', lang);
        },

        // NEW — PRICE READING LANGUAGE
        switchPriceLang(lang) {
            this.currentPriceLang = lang;
            Cookies.set('price_lang', lang, { expires: 365 });
        }
    }
};
</script>

<style scoped>
.language-page {
    background-color: var(--light);
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.header {
    background-color: white;
    padding: 16px 20px;
    border-bottom: 1px solid var(--light);
}

.header h1 {
    font-size: 28px;
    font-weight: 600;
    margin: 0;
    color: var(--color-0);
}

.section-title {
    padding: 16px 20px;
    font-size: 14px;
    font-weight: 600;
    color: var(--color-0);
    background-color: var(--light);
}

.language-options {
    background-color: white;
    border-top: 1px solid var(--light);
    border-bottom: 1px solid var(--light);
}

.language-option {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    cursor: pointer;
    position: relative;
    border-bottom: 1px solid var(--light);
    transition: background-color 0.2s;
}

.language-option:last-child {
    border-bottom: none;
}

.language-option:active {
    background-color: var(--light);
}

.language-option input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.radio-custom {
    width: 22px;
    height: 22px;
    border: 2px solid var(--color-c);
    border-radius: 50%;
    position: relative;
    flex-shrink: 0;
    transition: border-color 0.2s;
}

[dir="ltr"] .radio-custom {
    margin-right: 16px;
}

[dir="rtl"] .radio-custom {
    margin-left: 16px;
}

.language-option.active .radio-custom {
    border-color: #e53935;
}

.language-option.active .radio-custom::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: #e53935;
    border-radius: 50%;
}

.language-name {
    font-size: 17px;
    color: var(--color-0);
}

.language-option:not(.active) .language-name {
    color: var(--color-9);
}
</style>